module.exports = __webpack_public_path__ + "img/namibia.83471640.svg";